/**
 * F-plate-mask — os traços da placa entram SOZINHOS enquanto digita:
 * formato novo AA-123-CD (letras → dígitos → letras) e antigo 123-ABC-12.
 * Sequência fora dos padrões fica como digitada (só uppercase).
 * Compartilhado entre o portal do técnico e o portal do chantier.
 */
export function formatFrenchPlate(raw: string): string {
  const s = raw.toUpperCase().replace(/[^A-Z0-9]/g, "");
  const novo = s.match(/^([A-Z]{1,2})(\d{0,3})([A-Z]{0,2})$/);
  if (novo) {
    return [novo[1], novo[2], novo[3]].filter(Boolean).join("-");
  }
  const antigo = s.match(/^(\d{1,4})([A-Z]{0,3})(\d{0,2})$/);
  if (antigo) {
    return [antigo[1], antigo[2], antigo[3]].filter(Boolean).join("-");
  }
  return raw.toUpperCase();
}
